import { jsxs, jsx } from "react/jsx-runtime";
import { Table, Anchor, IconArrowUp, IconArrowDown } from "@zillow/constellation";
import "react";
const MortgageRateItem = ({
  rate,
  columns,
  blockProps
}) => {
  var _a;
  return /* @__PURE__ */ jsxs(Table.Row, { ...blockProps, children: [
    /* @__PURE__ */ jsx(Table.Cell, { children: ((_a = rate == null ? void 0 : rate.link) == null ? void 0 : _a.url) ? /* @__PURE__ */ jsx(Anchor, { href: rate.link.url, target: rate.link.opensInNewTab ? "_blank" : void 0, children: rate.program }) : rate.program }),
    columns.includes("rate") && /* @__PURE__ */ jsxs(Table.Cell, { children: [
      rate.rate,
      "%"
    ] }),
    columns.includes("rateChange") && /* @__PURE__ */ jsxs(Table.Cell, { children: [
      rate.isRateChangeUp ? /* @__PURE__ */ jsx(IconArrowUp, { fontColor: "red500", marginRight: "xs" }) : /* @__PURE__ */ jsx(IconArrowDown, { fontColor: "green500", marginRight: "xs" }),
      rate.rateChange,
      "%"
    ] }),
    columns.includes("apr") && /* @__PURE__ */ jsxs(Table.Cell, { children: [
      rate.apr,
      "%"
    ] }),
    columns.includes("aprChange") && /* @__PURE__ */ jsxs(Table.Cell, { children: [
      rate.isAprChangeUp ? /* @__PURE__ */ jsx(IconArrowUp, { fontColor: "red500", marginRight: "xs" }) : /* @__PURE__ */ jsx(IconArrowDown, { fontColor: "green500", marginRight: "xs" }),
      rate.aprChange,
      "%"
    ] })
  ] });
};
export {
  MortgageRateItem as default
};
